import { useEffect } from 'react';
import { ICustomFont } from '@typings/setting/fontManager';

const STYLE_TAG_ID = 'custom-fonts-style';

export function useCustomFonts(customFonts?: ICustomFont[]) {
  useEffect(() => {
    const existingTag = document.getElementById(STYLE_TAG_ID);

    if (!customFonts || customFonts.length === 0) {
      if (existingTag) {
        existingTag.remove();
      }
      return;
    }

    if (existingTag) {
      existingTag.remove();
    }

    const styleTag = document.createElement('style');
    styleTag.id = STYLE_TAG_ID;
    styleTag.textContent = customFonts
      .map((font) => font.cssText)
      .join('\n\n');

    document.head.appendChild(styleTag);

    return () => {
      styleTag.remove();
    };
  }, [customFonts]);
}

